


















import { defineComponent }                               from '@vue/composition-api';
import cIconPlusButton                                   from '@/components/icons/icon-plus-button.component.vue';
import cSectionTitle                                     from '@/components/section-title/section-title.component.vue';
import { useGlobals }                                    from '@/hooks/use-globals';
import { nameModeCreate as vDynamicTablesBuilderCreate } from '@/views/dynamic-tables-builder/dynamic-tables-builder.route';

export default defineComponent({
  name: 'cDynamicTablesHeader',
  components: {
    cIconPlusButton,
    cSectionTitle,
  },
  setup() {
    const { i18n } = useGlobals();
    const getTranslation = (value: string): string => (i18n.t(`vDynamicTables.${value}`)).toString();

    return {
      getTranslation,
      vDynamicTablesBuilderCreate,
    };
  },
});
